module.exports = __webpack_public_path__ + "bd48d815c3fd4497e734c29984b70924.svg";